import { keys } from "root/libs/constants/src";

export const preventSpaceBarScroll = (e) => {
  if (e.code === keys.SPACE) {
    e.preventDefault();
  }
};

export const isSpaceBar = (e) => e.code === keys.SPACE;
export const isEnter = (e) => e.code === keys.RETURN;
